
import scrollTo from './../utility/scrollTo'

function openTab(el, name) {
    const tabs = [...el.querySelectorAll('.tab')]
    const tabContent = [...el.querySelectorAll('.tab-content')]

    const newTab = el.querySelector(`[data-tab=${name}]`)
    const newTabContent = el.querySelector(`[data-tab-content=${name}]`)

    if (!newTabContent || !newTab) return false

    // remove current active state from tab and tab content
    tabs.map(tab => tab.classList.remove('tab--active'))
    tabContent.map(tab => tab.classList.remove('tab-content--active'))
    
    // add active state to new tab and tab content
    newTab.classList.add('tab--active')
    newTabContent.classList.add('tab-content--active')

    return true
}


function init(el, initialTab = '') {
    const links = [...el.querySelectorAll('[data-tab]')]
    
    if (initialTab) {
        openTab(el, initialTab) && scrollTo(el)
    }

    links.map(link => link.addEventListener('click', event => {
        const name = event.currentTarget.getAttribute('data-tab')
        openTab(el, name)
    }))
}

export default () => {
    const hash = window.location.hash?.substring(1) || ''
    const tabbed = [...document.querySelectorAll('.tabbed')]
    tabbed.map(el => init(el, hash))
}

